module.exports = __webpack_public_path__ + "static/media/fade04.5f641121.png";